import React from 'react';

export interface ChatProps {
    children?: React.ReactNode;
    className?: string;
}

/**
 * A chat column: a transcript that takes the available height above a composer that keeps its
 * own.
 *
 * `min-h-0` on the column is what lets `Chat.Thread` scroll rather than the page. Without it,
 * a flex child's implied `min-height: auto` grows the column past its parent and the scroll
 * moves to whichever ancestor can take it — which is not the same element in every engine.
 */
const ChatRoot: React.FC<ChatProps> = ({ children, className = '' }) => (
    <div className={`flex h-full min-h-0 min-w-0 flex-col ${className}`}>{children}</div>
);

export default ChatRoot;
